
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Refund terms',
    sec1Title: 'When a refund is possible',
    sec1Intro: 'A refund request may be reviewed if:',
    sec1Item1: 'money was charged but the balance was not credited;',
    sec1Item2: 'a technical error or a duplicate payment occurred;',
    sec1Item3: "paid digital content was not provided due to SHOT's fault;",
    sec1Item4: 'other confirmed technical problems were identified.',
    sec1Note:
      'Each request is reviewed individually. A request must be submitted no later than 30 calendar days from the top-up date.',
    sec2Title: 'When a refund is not possible',
    sec2Intro: 'A refund is not made if:',
    sec2Item1: 'the funds have already been used or multiplied;',
    sec2Item2: 'the balance, digital content or in-game item was successfully received;',
    sec2Item3: "the item was transferred to the user's Steam account;",
    sec2Item4: 'the user changed their mind after payment or did not read the Service terms;',
    sec2Item5: 'the request concerns the outcome of game mechanics;',
    sec2Item6:
      'the user violated the Service terms, or signs of fraud or abuse of the refund system were identified;',
    sec2Item7: 'more than 30 calendar days have passed since the top-up.',
    sec3Title: 'How to contact support',
    sec3Before: 'You need to contact SHOT support via the contacts listed in the ',
    sec3LinkWord: 'Support',
    sec3After:
      ' section. Payment details, additional data or documents may be required for verification.',
    sec4Title: 'Review period',
    sec4Text:
      'A request is reviewed after all the necessary information is received. The standard period is up to 30 calendar days. If additional verification or interaction with payment systems is required, the period may be extended.',
    policyLink: 'Detailed refund policy',
  },
  ru: {
    title: 'Условия возврата',
    sec1Title: 'Когда возможен возврат',
    sec1Intro: 'Запрос на возврат может быть рассмотрен, если:',
    sec1Item1: 'деньги были списаны, но баланс не был зачислен;',
    sec1Item2: 'произошла техническая ошибка или дублирование платежа;',
    sec1Item3: 'оплаченный цифровой контент не был предоставлен по вине SHOT;',
    sec1Item4: 'выявлены другие подтверждённые технические проблемы.',
    sec1Note:
      'Каждое обращение рассматривается индивидуально. Запрос необходимо подать не позднее 30 календарных дней с момента пополнения.',
    sec2Title: 'Когда возврат невозможен',
    sec2Intro: 'Возврат не производится, если:',
    sec2Item1: 'средства уже были использованы или преумножены;',
    sec2Item2: 'баланс, цифровой контент или игровой предмет были успешно получены;',
    sec2Item3: 'предмет был передан на Steam-аккаунт пользователя;',
    sec2Item4: 'пользователь изменил решение после оплаты или не ознакомился с условиями Сервиса;',
    sec2Item5: 'обращение связано с результатами игровых механик;',
    sec2Item6:
      'пользователь нарушил условия Сервиса либо выявлены признаки мошенничества или злоупотребления системой возвратов;',
    sec2Item7: 'с момента пополнения прошло более 30 календарных дней.',
    sec3Title: 'Как обратиться в поддержку',
    sec3Before: 'Необходимо обратиться в службу поддержки SHOT через контакты, указанные в разделе ',
    sec3LinkWord: 'Поддержка',
    sec3After:
      '. Для проверки могут потребоваться сведения о платеже, дополнительные данные или документы.',
    sec4Title: 'Срок рассмотрения',
    sec4Text:
      'Обращение рассматривается после получения всей необходимой информации. Стандартный срок — до 30 календарных дней. При необходимости дополнительной проверки или взаимодействия с платёжными системами срок может быть увеличен.',
    policyLink: 'Подробная политика возвратов',
  },
  uz: {
    title: 'Qaytarish shartlari',
    sec1Title: 'Qachon qaytarish mumkin',
    sec1Intro: 'Qaytarish soʻrovi koʻrib chiqilishi mumkin, agar:',
    sec1Item1: 'pul yechib olingan, lekin balans hisoblanmagan boʻlsa;',
    sec1Item2: 'texnik xatolik yoki toʻlov takrorlanishi yuz bergan boʻlsa;',
    sec1Item3: 'toʻlangan raqamli kontent SHOT aybi bilan taqdim etilmagan boʻlsa;',
    sec1Item4: 'boshqa tasdiqlangan texnik muammolar aniqlangan boʻlsa.',
    sec1Note:
      'Har bir murojaat alohida koʻrib chiqiladi. Soʻrov toʻldirilgan paytdan boshlab 30 kalendar kundan kechiktirmay yuborilishi kerak.',
    sec2Title: 'Qachon qaytarish mumkin emas',
    sec2Intro: 'Qaytarish amalga oshirilmaydi, agar:',
    sec2Item1: 'mablagʻ allaqachon ishlatilgan yoki koʻpaytirilgan boʻlsa;',
    sec2Item2: 'balans, raqamli kontent yoki oʻyin buyumi muvaffaqiyatli olingan boʻlsa;',
    sec2Item3: 'buyum foydalanuvchining Steam akkauntiga oʻtkazilgan boʻlsa;',
    sec2Item4: 'foydalanuvchi toʻlovdan keyin fikrini oʻzgartirgan yoki Servis shartlari bilan tanishmagan boʻlsa;',
    sec2Item5: 'murojaat oʻyin mexanikasi natijalari bilan bogʻliq boʻlsa;',
    sec2Item6:
      'foydalanuvchi Servis shartlarini buzgan yoki firibgarlik yoxud qaytarish tizimidan suiisteʼmol belgilari aniqlangan boʻlsa;',
    sec2Item7: 'toʻldirilgan paytdan 30 kalendar kundan koʻp vaqt oʻtgan boʻlsa.',
    sec3Title: 'Qoʻllab-quvvatlashga qanday murojaat qilish',
    sec3Before: 'SHOT ',
    sec3LinkWord: 'Qoʻllab-quvvatlash',
    sec3After:
      ' boʻlimida koʻrsatilgan kontaktlar orqali qoʻllab-quvvatlash xizmatiga murojaat qilish kerak. Tekshirish uchun toʻlov maʼlumotlari, qoʻshimcha maʼlumotlar yoki hujjatlar talab qilinishi mumkin.',
    sec4Title: 'Koʻrib chiqish muddati',
    sec4Text:
      'Murojaat barcha zarur maʼlumotlar olingandan keyin koʻrib chiqiladi. Standart muddat — 30 kalendar kungacha. Qoʻshimcha tekshiruv yoki toʻlov tizimlari bilan oʻzaro aloqa zarur boʻlsa, muddat uzaytirilishi mumkin.',
    policyLink: 'Batafsil qaytarish siyosati',
  },
  fa: {
    title: 'شرایط بازگشت وجه',
    sec1Title: 'چه وقت بازگشت وجه ممکن است',
    sec1Intro: 'درخواست بازگشت وجه ممکن است بررسی شود اگر:',
    sec1Item1: 'پول کسر شده اما موجودی شارژ نشده باشد؛',
    sec1Item2: 'خطای فنی یا پرداخت تکراری رخ داده باشد؛',
    sec1Item3: 'محتوای دیجیتال پرداخت‌شده به تقصیر SHOT داده نشده باشد؛',
    sec1Item4: 'مشکل فنی تأییدشده دیگری مشخص شده باشد.',
    sec1Note:
      'هر درخواست جداگانه بررسی می‌شود. درخواست باید حداکثر تا 30 روز تقویمی از تاریخ شارژ ثبت شود.',
    sec2Title: 'چه وقت بازگشت وجه ممکن نیست',
    sec2Intro: 'وجه برگردانده نمی‌شود اگر:',
    sec2Item1: 'پول قبلاً خرج یا چند برابر شده باشد؛',
    sec2Item2: 'موجودی، محتوای دیجیتال یا آیتم درون‌بازی با موفقیت دریافت شده باشد؛',
    sec2Item3: 'آیتم به حساب استیم کاربر منتقل شده باشد؛',
    sec2Item4: 'کاربر بعد از پرداخت نظرش عوض شده یا شرایط سرویس را نخوانده باشد؛',
    sec2Item5: 'درخواست درباره نتیجه مکانیک بازی باشد؛',
    sec2Item6:
      'کاربر شرایط سرویس را نقض کرده باشد، یا نشانه تقلب یا سوءاستفاده از سامانه بازگشت وجه دیده شود؛',
    sec2Item7: 'بیش از 30 روز تقویمی از شارژ گذشته باشد.',
    sec3Title: 'چطور با پشتیبانی تماس بگیریم',
    sec3Before: 'باید از راه‌های تماسِ بخش ',
    sec3LinkWord: 'پشتیبانی',
    sec3After: ' با تیم SHOT تماس بگیری. ممکن است برای بررسی، جزئیات پرداخت، داده یا مدرک بیشتری لازم شود.',
    sec4Title: 'مدت بررسی',
    sec4Text:
      'درخواست بعد از دریافت همه اطلاعات لازم بررسی می‌شود. مدت عادی تا 30 روز تقویمی است. اگر بررسی بیشتر یا هماهنگی با سامانه‌های پرداخت لازم باشد، این مدت طولانی‌تر می‌شود.',
    policyLink: 'سیاست کامل بازگشت وجه',
  },
  pt: {
    title: 'Condições de reembolso',
    sec1Title: 'Quando o reembolso é possível',
    sec1Intro: 'Um pedido de reembolso pode ser analisado se:',
    sec1Item1: 'o dinheiro foi debitado, mas o saldo não foi creditado;',
    sec1Item2: 'houve um erro técnico ou um pagamento duplicado;',
    sec1Item3: 'o conteúdo digital pago não foi entregue por culpa do SHOT;',
    sec1Item4: 'foram identificados outros problemas técnicos confirmados.',
    sec1Note:
      'Cada pedido é analisado individualmente. O pedido deve ser enviado em até 30 dias corridos a partir da data do depósito.',
    sec2Title: 'Quando o reembolso não é possível',
    sec2Intro: 'O reembolso não é feito se:',
    sec2Item1: 'os fundos já foram usados ou multiplicados;',
    sec2Item2: 'o saldo, o conteúdo digital ou o item do jogo foi recebido com sucesso;',
    sec2Item3: 'o item foi transferido para a conta Steam do usuário;',
    sec2Item4: 'o usuário mudou de ideia depois do pagamento ou não leu os termos do Serviço;',
    sec2Item5: 'o pedido se refere ao resultado das mecânicas do jogo;',
    sec2Item6:
      'o usuário violou os termos do Serviço ou foram identificados sinais de fraude ou abuso do sistema de reembolso;',
    sec2Item7: 'passaram mais de 30 dias corridos desde o depósito.',
    sec3Title: 'Como falar com o suporte',
    sec3Before: 'É preciso entrar em contato com o suporte do SHOT pelos contatos indicados na seção ',
    sec3LinkWord: 'Suporte',
    sec3After:
      '. Para a verificação, podem ser necessários dados do pagamento, informações adicionais ou documentos.',
    sec4Title: 'Prazo de análise',
    sec4Text:
      'O pedido é analisado depois que todas as informações necessárias forem recebidas. O prazo padrão é de até 30 dias corridos. Se for necessária uma verificação adicional ou contato com os sistemas de pagamento, o prazo pode ser estendido.',
    policyLink: 'Política de reembolso completa',
  },
  tr: {
    title: 'İade koşulları',
    sec1Title: 'İade ne zaman mümkün',
    sec1Intro: 'İade talebi şu durumlarda incelenebilir:',
    sec1Item1: 'para çekildi ama bakiyeye yansımadı;',
    sec1Item2: 'teknik bir hata ya da mükerrer ödeme oluştu;',
    sec1Item3: "ödenen dijital içerik SHOT'un hatası yüzünden sağlanmadı;",
    sec1Item4: 'doğrulanmış başka teknik sorunlar tespit edildi.',
    sec1Note:
      'Her başvuru ayrı ayrı incelenir. Talep, yatırma tarihinden itibaren en geç 30 takvim günü içinde gönderilmelidir.',
    sec2Title: 'İade ne zaman mümkün değil',
    sec2Intro: 'Şu durumlarda iade yapılmaz:',
    sec2Item1: 'para zaten kullanıldı ya da katlandı;',
    sec2Item2: 'bakiye, dijital içerik ya da oyun içi eşya başarıyla alındı;',
    sec2Item3: 'eşya kullanıcının Steam hesabına aktarıldı;',
    sec2Item4: 'kullanıcı ödemeden sonra fikrini değiştirdi ya da Servis koşullarını okumadı;',
    sec2Item5: 'başvuru oyun mekaniklerinin sonuçlarıyla ilgili;',
    sec2Item6:
      'kullanıcı Servis koşullarını ihlal etti ya da dolandırıcılık veya iade sisteminin kötüye kullanımına dair belirtiler tespit edildi;',
    sec2Item7: 'yatırmanın üzerinden 30 takvim gününden fazla geçti.',
    sec3Title: 'Desteğe nasıl ulaşılır',
    sec3Before: 'SHOT destek ekibine ',
    sec3LinkWord: 'Destek',
    sec3After:
      ' bölümünde belirtilen iletişim kanallarından ulaşman gerekir. Doğrulama için ödeme bilgileri, ek veriler ya da belgeler istenebilir.',
    sec4Title: 'İnceleme süresi',
    sec4Text:
      'Başvuru, gerekli tüm bilgiler alındıktan sonra incelenir. Standart süre 30 takvim gününe kadardır. Ek doğrulama ya da ödeme sistemleriyle iletişim gerekirse süre uzatılabilir.',
    policyLink: 'Ayrıntılı iade politikası',
  },
  uk: {
    title: 'Умови повернення',
    sec1Title: 'Коли можливе повернення',
    sec1Intro: 'Запит на повернення може бути розглянутий, якщо:',
    sec1Item1: 'гроші було списано, але баланс не було зараховано;',
    sec1Item2: 'сталася технічна помилка або дублювання платежу;',
    sec1Item3: 'оплачений цифровий контент не було надано з вини SHOT;',
    sec1Item4: 'виявлено інші підтверджені технічні проблеми.',
    sec1Note:
      'Кожне звернення розглядається індивідуально. Запит потрібно подати не пізніше ніж за 30 календарних днів із моменту поповнення.',
    sec2Title: 'Коли повернення неможливе',
    sec2Intro: 'Повернення не здійснюється, якщо:',
    sec2Item1: 'кошти вже було використано або примножено;',
    sec2Item2: 'баланс, цифровий контент або ігровий предмет було успішно отримано;',
    sec2Item3: 'предмет було передано на Steam-акаунт користувача;',
    sec2Item4: 'користувач передумав після оплати або не ознайомився з умовами Сервісу;',
    sec2Item5: 'звернення пов’язане з результатами ігрових механік;',
    sec2Item6: 'користувач порушив умови Сервісу або виявлено ознаки шахрайства чи зловживання системою повернень;',
    sec2Item7: 'з моменту поповнення минуло понад 30 календарних днів.',
    sec3Title: 'Як звернутися до підтримки',
    sec3Before: 'Потрібно звернутися до служби підтримки SHOT через контакти, вказані в розділі ',
    sec3LinkWord: 'Підтримка',
    sec3After: '. Для перевірки можуть знадобитися відомості про платіж, додаткові дані або документи.',
    sec4Title: 'Термін розгляду',
    sec4Text:
      'Звернення розглядається після отримання всієї необхідної інформації. Стандартний термін — до 30 календарних днів. За потреби додаткової перевірки або взаємодії з платіжними системами термін може бути збільшений.',
    policyLink: 'Докладна політика повернень',
  },
  de: {
    title: 'Rückerstattungsbedingungen',
    sec1Title: 'Wann eine Rückerstattung möglich ist',
    sec1Intro: 'Eine Rückerstattungsanfrage kann geprüft werden, wenn:',
    sec1Item1: 'Geld abgebucht, aber das Guthaben nicht gutgeschrieben wurde;',
    sec1Item2: 'ein technischer Fehler oder eine doppelte Zahlung aufgetreten ist;',
    sec1Item3: 'bezahlte digitale Inhalte aufgrund eines Verschuldens von SHOT nicht bereitgestellt wurden;',
    sec1Item4: 'andere bestätigte technische Probleme festgestellt wurden.',
    sec1Note:
      'Jede Anfrage wird einzeln geprüft. Die Anfrage muss spätestens 30 Kalendertage nach der Aufladung gestellt werden.',
    sec2Title: 'Wann keine Rückerstattung möglich ist',
    sec2Intro: 'Eine Rückerstattung erfolgt nicht, wenn:',
    sec2Item1: 'die Mittel bereits verwendet oder vermehrt wurden;',
    sec2Item2: 'das Guthaben, der digitale Inhalt oder das Spiel-Item erfolgreich erhalten wurde;',
    sec2Item3: 'das Item auf das Steam-Konto des Nutzers übertragen wurde;',
    sec2Item4:
      'der Nutzer es sich nach der Zahlung anders überlegt oder die Bedingungen des Dienstes nicht gelesen hat;',
    sec2Item5: 'die Anfrage das Ergebnis von Spielmechaniken betrifft;',
    sec2Item6:
      'der Nutzer gegen die Bedingungen des Dienstes verstoßen hat oder Anzeichen für Betrug oder Missbrauch des Rückerstattungssystems festgestellt wurden;',
    sec2Item7: 'seit der Aufladung mehr als 30 Kalendertage vergangen sind.',
    sec3Title: 'So wendest du dich an den Support',
    sec3Before: 'Wende dich an den SHOT-Support über die Kontakte im Abschnitt ',
    sec3LinkWord: 'Support',
    sec3After: '. Zur Prüfung können Zahlungsdetails, zusätzliche Daten oder Dokumente erforderlich sein.',
    sec4Title: 'Bearbeitungsdauer',
    sec4Text:
      'Eine Anfrage wird geprüft, sobald alle nötigen Informationen vorliegen. Die übliche Frist beträgt bis zu 30 Kalendertage. Ist eine zusätzliche Prüfung oder Abstimmung mit Zahlungssystemen nötig, kann sich die Frist verlängern.',
    policyLink: 'Ausführliche Rückerstattungsrichtlinie',
  },
  es: {
    title: 'Condiciones de reembolso',
    sec1Title: 'Cuándo es posible un reembolso',
    sec1Intro: 'Se puede revisar una solicitud de reembolso si:',
    sec1Item1: 'se cobró el dinero pero no se acreditó el saldo;',
    sec1Item2: 'ocurrió un error técnico o un pago duplicado;',
    sec1Item3: 'el contenido digital pagado no se entregó por culpa de SHOT;',
    sec1Item4: 'se detectaron otros problemas técnicos confirmados.',
    sec1Note:
      'Cada solicitud se revisa de forma individual. La solicitud debe presentarse a más tardar 30 días naturales después de la recarga.',
    sec2Title: 'Cuándo no es posible un reembolso',
    sec2Intro: 'No se hace reembolso si:',
    sec2Item1: 'los fondos ya se usaron o se multiplicaron;',
    sec2Item2: 'el saldo, el contenido digital o el objeto del juego se recibió correctamente;',
    sec2Item3: 'el objeto se transfirió a la cuenta de Steam del usuario;',
    sec2Item4: 'el usuario cambió de opinión tras el pago o no leyó las condiciones del Servicio;',
    sec2Item5: 'la solicitud se refiere al resultado de las mecánicas de juego;',
    sec2Item6:
      'el usuario incumplió las condiciones del Servicio o se detectaron indicios de fraude o abuso del sistema de reembolsos;',
    sec2Item7: 'han pasado más de 30 días naturales desde la recarga.',
    sec3Title: 'Cómo contactar con soporte',
    sec3Before: 'Debes contactar con el soporte de SHOT a través de los contactos indicados en la sección ',
    sec3LinkWord: 'Soporte',
    sec3After: '. Para la verificación pueden hacer falta datos del pago, información adicional o documentos.',
    sec4Title: 'Plazo de revisión',
    sec4Text:
      'La solicitud se revisa una vez recibida toda la información necesaria. El plazo habitual es de hasta 30 días naturales. Si hace falta una verificación adicional o interactuar con los sistemas de pago, el plazo puede ampliarse.',
    policyLink: 'Política de reembolsos detallada',
  },
  pl: {
    title: 'Warunki zwrotu',
    sec1Title: 'Kiedy zwrot jest możliwy',
    sec1Intro: 'Wniosek o zwrot może zostać rozpatrzony, jeśli:',
    sec1Item1: 'pieniądze zostały pobrane, ale saldo nie zostało doładowane;',
    sec1Item2: 'wystąpił błąd techniczny lub zdublowanie płatności;',
    sec1Item3: 'opłacone treści cyfrowe nie zostały dostarczone z winy SHOT;',
    sec1Item4: 'wykryto inne potwierdzone problemy techniczne.',
    sec1Note:
      'Każde zgłoszenie jest rozpatrywane indywidualnie. Wniosek trzeba złożyć nie później niż 30 dni kalendarzowych od doładowania konta.',
    sec2Title: 'Kiedy zwrot jest niemożliwy',
    sec2Intro: 'Zwrot nie jest dokonywany, jeśli:',
    sec2Item1: 'środki zostały już wykorzystane lub pomnożone;',
    sec2Item2: 'saldo, treści cyfrowe lub przedmiot z gry zostały pomyślnie otrzymane;',
    sec2Item3: 'przedmiot został przekazany na konto Steam użytkownika;',
    sec2Item4: 'użytkownik zmienił zdanie po płatności lub nie zapoznał się z warunkami Serwisu;',
    sec2Item5: 'zgłoszenie dotyczy wyników mechanik gry;',
    sec2Item6: 'użytkownik naruszył warunki Serwisu albo wykryto oznaki oszustwa lub nadużycia systemu zwrotów;',
    sec2Item7: 'od doładowania konta minęło ponad 30 dni kalendarzowych.',
    sec3Title: 'Jak skontaktować się ze wsparciem',
    sec3Before: 'Skontaktuj się ze wsparciem SHOT przez dane kontaktowe podane w sekcji ',
    sec3LinkWord: 'Wsparcie',
    sec3After: '. Do weryfikacji mogą być potrzebne dane płatności, dodatkowe informacje lub dokumenty.',
    sec4Title: 'Czas rozpatrzenia',
    sec4Text:
      'Zgłoszenie jest rozpatrywane po otrzymaniu wszystkich niezbędnych informacji. Standardowy czas to do 30 dni kalendarzowych. Jeśli potrzebna jest dodatkowa weryfikacja lub kontakt z systemami płatności, czas może zostać wydłużony.',
    policyLink: 'Szczegółowa polityka zwrotów',
  },
});
